module.exports = __webpack_public_path__ + "static/media/arogyagram.46c5eff8.png";